import React, { useEffect } from "react";
import { useForm, useWatch } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";

import { copy } from "shared/assets";
import { RadioGroup } from "shared/components";
import { space } from "shared/styles/constants";
import { IAPIError, IDataKeys, IFormButtons } from "shared/types";

import { clearActionMeta, clearDataByKey, dataMetaSelector, flightSelector } from "Bands/state";
import { BAND_ACTIONS, IEventFlightTravelLegParams, IEventSuggestedLocation } from "Bands/types";

import { useEventContext } from "Bands/contexts";
import { EventFlightTravelLegFormDetails } from "./EventFlightTravelLegFormDetails";
import { EventFlightTravelLegPrefillForm } from "./EventFlightTravelLegPrefillForm";

const flightFields = copy.travelBlock.flight.fields;

interface Props {
  isSubmitting?: boolean;
  error?: string | boolean;
  defaultValues?: IEventFlightTravelLegParams;
  buttons?: IFormButtons;
  apiError?: IAPIError | null;
  handleSubmit: (data: IEventFlightTravelLegParams) => void;
  defaultSuggestedLocations?: IEventSuggestedLocation[];
}

enum FlightTravelFormOptions {
  "PREFILL" = "prefill",
  "MANUAL" = "manual",
}

const radioOptions = [
  {
    value: FlightTravelFormOptions.PREFILL,
    label: flightFields.searchFlight,
  },
  {
    value: FlightTravelFormOptions.MANUAL,
    label: flightFields.manuallyAddFlight,
  },
];

type FormData = {
  flightSearchType: string;
};

export const EventFlightTravelLegForm: React.FC<Props> = props => {
  const defaultValues = {
    flightSearchType: FlightTravelFormOptions.PREFILL as FlightTravelFormOptions,
  };

  const dispatch = useDispatch();
  const { register, control } = useForm<FormData>({ defaultValues });
  const { flightSearchType } = useWatch({ control });
  const { event } = useEventContext();
  const suggestedFlights = useSelector(flightSelector);

  const { api: apiMeta } = useSelector(dataMetaSelector(BAND_ACTIONS.fetchPrefillFlight));

  useEffect(() => {
    dispatch(clearActionMeta(IDataKeys.scheduledFlight));
    dispatch(clearDataByKey(IDataKeys.scheduledFlight));
  }, [dispatch]);

  return (
    <>
      <form style={{ marginBottom: space.s }}>
        <RadioGroup options={radioOptions} name="flightSearchType" registerRef={register} />
      </form>

      {flightSearchType === "prefill" && <EventFlightTravelLegPrefillForm apiMeta={apiMeta} />}

      <EventFlightTravelLegFormDetails
        {...props}
        event={event}
        suggestedFlights={suggestedFlights}
      />
    </>
  );
};
